<template>
    <div class="header">
        <b-navbar toggleable="lg" type="dark" variant="dark" style="min-height: 100px" sticky class="p-0">
            <b-navbar-brand to="/">
                    <b-icon id="icon" icon="house" style="color: white; height: 50px; width: 50px; margin-left: 30px; margin-top: 5px"></b-icon>
            </b-navbar-brand>

            <b-navbar-toggle class="mr-3" target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto mt-2">
                    <b-nav-item class="ml-3 mt-3" style="width: auto; height: 50px;" to="/blog">
                        <a class="menu-link" href="#">Blog</a>
                    </b-nav-item>
                    <b-nav-item class="ml-3 mt-3" style="width: auto; height: 50px" to="/about">
                        <a class="menu-link" href="#">About</a>
                    </b-nav-item>
                    <b-nav-item v-if="this.isAuthenticated" class="ml-3 mt-3" style="width: auto; height: 50px" to="/write">
                        <a class="menu-link" href="#">Write</a>
                    </b-nav-item>
                    <b-nav-item v-if="this.isAuthenticated" class="ml-3 mt-3" style="width: auto; height: 50px" to="/dashboard">
                        <a class="menu-link" href="#">Dashboard</a>
                    </b-nav-item>
                    <b-nav-item class="ml-3 mt-3" style="width: auto; height: 70px; margin-right: 100px" to="/contact">
                        <a class="menu-link" href="#">Contact</a>
                    </b-nav-item>
                </b-navbar-nav>
            </b-collapse>

        </b-navbar>
    </div>
</template>

<script>

    import {mapGetters} from "vuex";

    export default {
        name: 'Header',
        components: {
        },
        computed: {
            ...mapGetters(['isAuthenticated']),
        },
    };


</script>

<style>

    .header {
        width: 100vw;

    }

    .menu-link {
        font-size: 40px;
        font-family: "Dosis", sans-serif;
        margin-top: -15px;
    }

    .menu-link:link {
        float: left;
        color: white;
    }

    /* visited link */
    .menu-link:visited {
        color: white;
    }

    /* mouse over link */
    .menu-link:hover {
        color: lightgrey;
    }

    /* selected link */
    .menu-link:active {
        color: white;
    }

    .navbar.navbar-dark .navbar-toggler-icon {
        height: 50px;
        width: 50px;
        margin-right: 10px;
    }

    @media only screen and (max-width: 599px) {
        li.nav-item.ml-3.mt-3 {
            height: 80px!important;
        }
    }

    @media only screen and (min-width: 820px) and (max-width: 991px) {
        li.nav-item.ml-3.mt-3 {
            height: 80px!important;
        }
    }


</style>
